import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcPermissionRequestIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { usePermissionRequestsButtonPresenter } from './PermissionRequestsButton.presenter';
import styles from './PermissionsRequestsButton.styles.m.css';

export const PermissionRequestButton: FC = observer(() => {
  const presenter = usePermissionRequestsButtonPresenter();
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={presenter.onClick}
      className={styles.link}
      iconClassName={styles.icon}
      Icon={IcPermissionRequestIcon}
      textContainerClassName={styles.textContainer}
      theme="11"
      text={
        <div className={styles.requestsText}>
          {t('call_permission_requests')}{' '}
          <span className={styles.requestsCount}>{presenter.permissionsRequestsCount}</span>
        </div>
      }
      size={IconViewSizes.Large}
      iconSize={IconViewSizes.Auto}
    />
  );
});
